'use strict';

angular.module('cvsApp').controller('ConfirmPaymentsCtrl', ["$scope", "userSession", "$state", "webAnalytics", "webTrendsService", "loggerService", "loggerServiceHelper", "$rootScope",
  function ($scope, UserSession, $state, webAnalytics, WTS, loggerService, loggerServiceHelper, $rootScope) {
    var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.PAYMENT_REGISTERED) + loggerServiceHelper.setFlowType(UserSession.paymentType) + loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.PaymentConfirmation));
    log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.START));

    /*Scroll to top*/
    cvsUtility.genralPostMessage("SCROLL_TO", {
      "scroll": true
    });

    /**
     * Created by z241843 viswa on 03/03/2020.
     * Start: GST-189 UI - Create tags for payment confirmation page on page load.
     * Added WTS pagename tag
     */
    var utagObj = {};
    utagObj.page_name = 'srx: payment confirmation';
    utagObj.adobe_page_name = 'cvssp' + '|' + cvsUtility.getPlatform() + '|' + utagObj.page_name;
    utagObj.page_category = 'payments';
    if (UserSession) {
      utagObj.payment_amount = UserSession.paymentAmount; //Payment Amount
      utagObj.event_name = 'event24' + ',' + 'event5' + '=' + UserSession.paymentAmount;
      /*
       * Choose a payment method 
       * if credit card or Debit card or HSA card  or FSA card fire "credit card". If it is bank fire "bank account" 
       * if auto payments Fire  recurring-ccard or recurring-check
       */
      if (UserSession.paymentType !== "auto") {
        if (UserSession.paymentMopType == "CCARD") {
          utagObj.spx_payment_method = "credit card";
        } else if (UserSession.paymentMopType == "CHECK") {
          utagObj.spx_payment_method = "bank account";
        }
      } else {
        if (UserSession.paymentMopType == "CCARD") {
          utagObj.spx_payment_method = "recurring-ccard";
        } else if (UserSession.paymentMopType == "CHECK") {
          utagObj.spx_payment_method = "recurring-check";
        }
      }

      // make a payment either one time or recurring  
      // Ex: Payment_freq: 400 | Each Month |6 and 100 | Immediate | 0
      if (UserSession.paymentType !== "auto") {
        utagObj.payment_type = "One Time";
        utagObj.spx_recurring_payment_freq = UserSession.paymentAmount + "|" + "Immediate" + "|" + "0";
      } else {
        utagObj.payment_type = "Recurring";
        utagObj.spx_recurring_payment_freq = UserSession.reviewPageAutoPay.limit + "|" + "Each Month" + "|" + UserSession.autoPay.schedule;
      }

      if (UserSession.registered) {
        // Do nothing
      } else {
        utagObj.tsrc = cvsUtility.queryMap.source;
      }

    }
    WTS.webTrendsUtag("OBJ", utagObj);
    /* End : GST-189 UI - Create tags for payment confirmation page on page load */

    // if (UserSession.registered) {
    //   if (UserSession.paymentType !== "auto") {
    //     utagObj = {
    //       scenario_step: '1-time pay success',
    //       "tsrc": cvsUtility.queryMap.source
    //     };
    //   } else {
    //     utagObj = {
    //       scenario_step: 'recurring pay success'
    //     };
    //   }
    //   /**
    //    * z227308 11/22/2016 - ITPR017031 - added paymentConfirmation
    //    * Added WTS pagename tag
    //    */

    //   if (self == top) {
    //     utagObj.pagename = "PAYMENT-paymentConfirmation";
    //   }
    //   webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "paymentConfirmation");

    // } else {
    //   utagObj = {
    //     "tsrc": cvsUtility.queryMap.source
    //   };

    //   /**
    //    * z227308 11/22/2016 - ITPR017031 - added guestPaymentSubmitted
    //    * Added WTS pagename tag
    //    */

    //   if (self == top) {
    //     utagObj.pagename = "PAYMENT-guestPaymentSubmitted";
    //   }
    //   webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "guestPaymentSubmitted");
    // }
    $scope.content = wcmContent;

    $scope.hideSavePrntBtnApp = function () {
      if (cvsUtility.getPlatform() === 'mapp') {
        return false;
      }
      return true;
    }

    $scope.saveConfirm = function () {
      log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep("saveConfirmPage") + loggerServiceHelper.setDescription("Save Confirm Page"));
      window.print();
      log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setDescription("SaveConfirmPage Loading Done"));
    };
    var _registered = true;
    if (cvsUtility.queryMap.tokenId) {
      _registered = true;
    } else {
      _registered = false;
    }
    $scope.returnToHome = function () {
      log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep("returnToHome") + loggerServiceHelper.setDescription("returnToHome"));
      log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
      if (_registered) {
        $rootScope.paymentConfirmationPageReturn = true;
        UserSession.init(_registered);
      } else {
        UserSession.init(_registered, 'guest', UserSession.guestTokenID);
      }
      $state.go("account-balance");
    };
    var paymentType = UserSession && UserSession.paymentType;
    var balance = UserSession && UserSession.paymentAmount ? UserSession.paymentAmount : 0;
    $scope.message = $scope.content.specialty_recurring_payment.pymt_submit_success;
    //cvsUtility.resetSessoinTimeOut();
    if (paymentType !== "auto") {
      $scope.message = $scope.content.specialty_recurring_payment.pymt_submit_success;
      $scope.successfulPaymentAlertConfig = {
        alertType: "success",
        title: "",
        message: $scope.message,
        suppressIcon: false
      }
    } else if (balance == 0) {
      $scope.message = $scope.content.specialty_recurring_payment.pamnt_enabled_success;
      $scope.successfulPaymentAlertConfig = {
        alertType: "success",
        title: "",
        message: $scope.message,
        suppressIcon: false
      }
    } else if (balance > 0) {
      $scope.message = $scope.content.specialty_recurring_payment.pmnt_scheduled_success;
      $scope.successfulPaymentAlertConfig = {
        alertType: "success",
        title: "",
        message: $scope.message,
        suppressIcon: false
      }
    }


    log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setDescription("Confirm Payment payment page load completed"));

  }
]);